// extracted by mini-css-extract-plugin
module.exports = {"copyContent":"CopyToClipboard__copyContent"};